import React from 'react'
import CustomTheme from '../CustomTheme'
import Typography from '@mui/material/Typography'

/** usage example
    <Texts.H1
        sx={{
            color: 'inherit',
            flexGrow: 1,
            textAlign: 'center'
        }}
    >{"Header text"}</Texts.H1>
 */

const H1 = React.forwardRef((props, ref) => {
    return (
        <CustomTheme>
            <Typography
                id={props.id}
                ref={ref}
                variant="h1"
                sx={{
                    color: "text.primary"
                }}
                {...props}
            >
                {props.children}
            </Typography>
        </CustomTheme>
    )
})

const H2 = React.forwardRef((props, ref) => {
    return (
        <CustomTheme>
            <Typography
                id={props.id}
                ref={ref}
                variant="h2"
                sx={{
                    color: "text.primary"
                }}
                {...props}
            >
                {props.children}
            </Typography>
        </CustomTheme>
    )
})

const H3 = React.forwardRef((props, ref) => {
    return (
        <CustomTheme>
            <Typography
                id={props.id}
                ref={ref}
                variant="h3"
                sx={{
                    color: "text.primary"
                }}
                {...props}
            >
                {props.children}
            </Typography>
        </CustomTheme>
    )
})

const H4 = React.forwardRef((props, ref) => {
    return (
        <CustomTheme>
            <Typography
                id={props.id}
                ref={ref}
                variant="h4"
                sx={{
                    color: "text.primary"
                }}
                {...props}
            >
                {props.children}
            </Typography>
        </CustomTheme>
    )
})


const H5 = React.forwardRef((props, ref) => {
    return (
        <CustomTheme>
            <Typography
                id={props.id}
                ref={ref}
                variant="h5"
                sx={{
                    color: "text.primary"
                }}
                {...props}
            >
                {props.children}
            </Typography>
        </CustomTheme>
    )
})

const H6 = React.forwardRef((props, ref) => {
    return (
        <CustomTheme>
            <Typography
                id={props.id}
                ref={ref}
                variant="h6"
                sx={{
                    color: "text.primary"
                }}
                {...props}
            >
                {props.children}
            </Typography>
        </CustomTheme>
    )
})

const Tip = React.forwardRef((props, ref) => {
    return (
        <Typography
            id={props.id}
            ref={ref}
            onClick={props.onClick !== null ? props.onClick : null}
            variant="subtitle2"
            {...props}
            sx={{
                color: "text.primary",
                m: 0,
                p: 0,
                ...props.sx
            }}
        >
            {props.children}
        </Typography>
    )
})

const SmallTip = React.forwardRef((props, ref) => {
    return (
        <Typography
            id={props.id}
            ref={ref}
            onClick={props.onClick !== null ? props.onClick : null}
            variant="overline"
            {...props}
            sx={{
                color: "text.primary",
                m: 0,
                p: 0,
                ...props.sx
            }}
        >
            {props.children}
        </Typography>
    )
})


const Text = React.forwardRef((props, ref) => {
    return (
        <CustomTheme>
            <Typography
                id={props.id}
                ref={ref}
                variant="body1"
                {...props}
                sx={{
                    color: "text.primary",
                    ...props.sx
                }}
            >
                {props.children}
            </Typography>
        </CustomTheme>
    )
})
/** usage example
    <Texts.Paragraph
        sx={{
            color: 'inherit',
            flexGrow: 1,
            textAlign: 'center'
        }}
    >{"your paragraph"}</Texts.Paragraph>
 */
const Paragraph = React.forwardRef((props, ref) => {
    return (
        <CustomTheme>
            <Typography
                id={props.id}
                ref={ref}
                className={props.className}
                variant="body2"
                {...props}
                sx={{
                    color: "text.primary",
                    ...props.sx
                }}
            >
                {props.children}
            </Typography>
            {/*<article id={props.id} ref={ref}>
                <p className={`fyw-paragraph ${props.className}`} style={props.style}>
                    {props.children}
                </p>
        </article>*/}
        </CustomTheme>
    )
})

const Title = React.forwardRef((props, ref) => {
    return (
        <Typography
            variant="h4"
            id={props.id}
            ref={ref}
            {...props}
            sx={{
                color: "text.primary",
                ...props.sx
            }}
        >
            {props.children}
        </Typography>
    )
})

const Subtitle = React.forwardRef((props, ref) => {
    return (
        <Typography
            variant="h6"
            id={props.id}
            ref={ref}
            {...props}
            sx={{
                color: "text.primary",
                ...props.sx
            }}
        >
            {props.children}
        </Typography>
    )
})

export { Tip, Text, Title, Subtitle, Paragraph, H1, H2, H3, H4, H5, H6, SmallTip }